import React from 'react'

import './FormDataPoint.css'

export default function FormDataPoint({ label, value }) {
    return (<div className='form-data-point'>
        <div className='form-data-point-label'>{ label }</div>
        <div className='form-data-point-value'>{ value }</div>
    </div>)
}